export enum MenuItems {
    DASHBOARD = 'DASHBOARD',
    DOCUMENTS = 'DOCUMENTS',
    CHAT = 'CHAT',
    SUPPORTO = 'SUPPORTO',
    F24 = 'F24',
    BALANCE = 'BALANCE',
    EMPLOYEE = 'EMPLOYEE',
    OTHER = 'OTHER'
}